import React from 'react'
import "./Library.css";
import {blog01,blog02,blog04,blog05,blog03} from "../../constants"
function Library() {
  return (
    <div className="App_library" id="Library">
      <div className="App_library-container">
        <p className="library-title">
          A lot is happening,
          We are blogging about it.
        </p>


        <div className="library-blogs">
          <div className="blog">
            <img src={blog01} alt="blog01" />
            <div className="blog_desc">
              <span className="date">Sep 26,2022</span>
              <p className="info-intro">
                GPT - 3 and Open AI is the future.Let us exlore how it is ?
              </p>

               <span className = "span_btn">
                Read Full Article
              </span>
            </div>
          </div>
         
          <div className="blog">
            <img src={blog03} alt="blog03" />
            <div className="blog_desc">
              <span className="date">Sep 26,2022</span>
              <p className="info-intro">
                GPT - 3 and Open AI is the future.Let us exlore how it is ?
              </p>
              <span className = "span_btn" >
                Read Full Article
              </span>
            </div>

           
          </div>
          <div className="blog">
            <img src={blog04} alt="blog04" />
            <div className="blog_desc">
              <span className="date">Sep 26,2022</span>
              <p className="info-intro">
                GPT - 3 and Open AI is the future.Let us exlore how it is ?
              </p>
              <span className = "span_btn">
                Read Full Article
              </span>
            </div>

            
          </div>
          <div className="blog">
            <img src={blog05} alt="blog05" />
            <div className="blog_desc">
              <span className="date">Sep 26,2022</span>
              <p className="info-intro">
                GPT - 3 and Open AI is the future.Let us exlore how it is ?
              </p>
              <span className = "span_btn" >
                Read Full Article
              </span>
            </div>
          </div>
          <div className="blog">
            <img src={blog02} alt="blog02" />
            <div className="blog_desc">
              <span className="date">Sep 26,2022</span>
              <p className="info-intro">
                GPT - 3 and Open AI is the future.Let us exlore how it is ?
              </p>

              <span className = "span_btn" >
                Read Full Article
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Library